import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimFileExtension',
})
export class TrimFileExtensionPipe implements PipeTransform {
  transform(filename: string): string {
    return filename.indexOf('.') < 0
      ? filename
      : filename.split('.').slice(0, -1).join('.');
  }
}
